export const FETCH_ALL_MEMBERS_REQUEST = "FETCH_ALL_MEMBERS_REQUEST";
export const FETCH_ALL_MEMBERS_SUCCESS = "FETCH_ALL_MEMBERS_SUCCESS";
export const FETCH_ALL_MEMBERS_FAILURE = "FETCH_ALL_MEMBERS_FAILURE";

export const FETCH_ACTIVE_MEMBERS_REQUEST = "FETCH_ACTIVE_MEMBERS_REQUEST";
export const FETCH_ACTIVE_MEMBERS_SUCCESS = "FETCH_ACTIVE_MEMBERS_SUCCESS";
export const FETCH_ACTIVE_MEMBERS_FAILURE = "FETCH_ACTIVE_MEMBERS_FAILURE";

